module.exports = __webpack_public_path__ + "static/media/Club.0cac41f3.webp";